import React from "react";
import Slider from "react-slick/lib";
import { withRouter } from "react-router";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import ls from "local-storage";
import * as CONFIG from "./_config";
import RV from "simple-react-validator";
import { toast } from "react-toastify";
import Moment from "react-moment";
import AOS from "aos";
import "aos/dist/aos.css";
import { sanitizeUrlForCSS, sanitizeUrlForHtml } from './helper/helper';

const axios = require("axios");

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    this.myRef = React.createRef();

    this.state = {
      formControls: {},
      dealoftheweek: [],
      weeklyadgallery: [],
      departments: [],
      dept_info: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.DealoftheWeek();
      this.WeeklyAdGallery();
      this.Departments();
      //  this.renderDepartment();

      ls.set("redirectTo", window.location.href);
      AOS.init({
        duration: 100,
      });
    }
  }

  componentDidMount() {
    this.TryAutoLogin();
    this.DealoftheWeek();
    this.WeeklyAdGallery();
    this.Departments();

    ls.set("redirectTo", window.location.href);
    AOS.init({
      duration: 100,
    });
  }

  DealoftheWeek() {
    const data = new FormData();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    data.append("method", "POST");
    //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetDetailsForCoupons/10001/${UserToken}/0`);
    // data.append(
    //   "apiurl",
    //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetDetailsForCoupons/10002/${UserToken}/0`
    // );

    var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetDetailsForCoupons/10002/${UserToken}/0`;

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        this.setState({ dealoftheweek: res.data.Specials });
        // console.log('dealoftheweek', this.state);
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  WeeklyAdGallery() {
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN;
    var ClientStoreId = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).ClientStoreId
      : CONFIG.DATA.RSA_CLIENT_STORE_ID;

    //const data = new FormData();
    //data.append("method", "GET");

    // data.append(
    //   "apiurl",
    //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/services/SSWebRestApi.svc/WeeklyAdGallery/${UserToken}/${ClientStoreId}`
    // );
    var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/WeeklyAdGallery/${UserToken}/${ClientStoreId}`;

    axios
      .get(apiurl, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        if (res.data.GalleryItems)
          this.setState({ weeklyadgallery: res.data.GalleryItems });
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  Departments() {
    if (CONFIG.DATA.BASIC_THEME === true) {
      return;
    }

    var Departments = ls.get("Departments");
    if (Departments) {
      // console.log("storage");
      this.setState({ departments: Departments });
    } else {
      var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
        ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
        : CONFIG.DATA.GUEST_TOKEN_USER;
      const data = new FormData();
      data.append("method", "POST");
      // data.append(
      //   "apiurl",
      //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetCategoriesForCoupons/${UserToken}`
      // );
      var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetCategoriesForCoupons/${UserToken}`;
      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })
        .then((res) => {
          if (res.data.GetProductCategories)
            this.setState({ departments: res.data.GetProductCategories });
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }

  gotoDept(path) {
    //this.setState({redirect: true, path: path});
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      formControls: { ...this.state.formControls, [name]: value },
    });
  };

  Subscribe = async (e) => {
    // console.log(this.state.formControls);
    e.preventDefault();
    const datails = this.state.formControls;
    var body = "<table> &&& </table>";
    var tr = "";

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return false;
    }

    for (let [key, value] of Object.entries(datails)) {
      tr += "<tr><td>" + key + "</td><td>" + value + "</td></tr>";
    }

    body = body.replace("&&&", tr);

    const data = new FormData();
    data.append("method", "POST");
    var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/SendEmail`;

    data.append("EmailId", CONFIG.DATA.SUBSCRIPTION_EMAIL);
    data.append("EmailSubject", "Enquiry for Subscribe");
    data.append("EmailBody", body);
    data.append("RSAClientId", "XXX");
    data.append("EnterpriseId", "CE6693D83B834CEAB4FA533E604EE58B");
    data.append("SecurityKey", "7C9EF435200042FD953733EBF85B1A3D");
    data.append("CCList", "");
    data.append("BccList", "");

    if (CONFIG.DATA.FROM_EMAIL_ID) {
      data.append("FromEmailId", CONFIG.DATA.FROM_EMAIL_ID);
    } else {
      data.append("FromEmailId", "clientsupport@rsagroceryapp.com");
    }
    data.append("FromName", CONFIG.DATA.RSA_CLIENT_APP_NAME);
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        if (res.data.ErrorMessage.ErrorCode === 1) {
          this.setState({
            formControls: {},
          });
          toast.success("An email has been sent!");
          document.getElementById("SubscribeForm").reset();
        }
      })
      .catch(function (response) {
        console.log(response);
      });
  };

  AddtoCart = async (event, index) => {
    event.preventDefault();
    event.persist();

    if (!ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)) {
      toast.info("Please login to add item to cart!");
      // ls.set('redirectTo', this.props.history.location.pathname);
      ls.set("redirectTo", window.location.href);
      this.props.history.push("/login");
      return false;
    }

    //this.setState({ disableaddtocart:true});

    var button_span = null;
    if (event.target && event.target.tagName.toLowerCase() === "span") {
      button_span = document.getElementById(event.target.id);
    } else if (
      event.target &&
      event.target.tagName.toLowerCase() === "button"
    ) {
      var button = document.getElementById(
        event.target.id
      ); /* id is unique by definition! */
      var spans = button.getElementsByTagName("span");
      if (spans) button_span = spans[0];
    }

    if (button_span === null) {
      return false;
    }

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;

    // console.log('deaild',details);
    if (index !== null && index > -1) {
      // var product = JSON.parse(details,true)
      var dealoftheweek = this.state.dealoftheweek;
      var product = dealoftheweek[index];

      this.setState({ show: false });
      // console.log('productproduct',product);

      const data = new FormData();

      if (product) {
        if (button_span.getAttribute("data-action") !== "remove") {
          //if (!product.IsInCart) {
          var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/SaveMyCart`;
          data.append("method", "POST");
          // data.append(
          //   "apiurl",
          //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/SaveMyCart`
          // );
          data.append(
            "OfferId",
            product.SSNewsId ? product.SSNewsId : product.SSNewsId
          );
          data.append("CategoryId", product.NewsCategoryId);
          data.append(
            "MemberNumber",
            ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).MemberNumber
          );
          data.append("UserFirstName", product.CustomerName);
          data.append("NCRPromotionCode", product.NCRPromotionCode);
          data.append("IsInNCRImpressions", product.IsInNCRImpressions);
          data.append("Title", product.Title);
          data.append("Details", product.Details);
          data.append("Amount", product.Amount);
          data.append("ProductName", product.ProductName);
          data.append("ValidFrom", product.ValidFromDate);
          data.append("ExpiresOn", product.ExpiresOn);
          data.append("UPC", "");
          data.append("UserToken", UserToken);

          var object = {};
          data.forEach((value, key) => (object[key] = value));
          var jsonData = JSON.stringify(object);

          axios
            .post(apiurl, jsonData, {
              headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
            })
            .then((res) => {
              // console.log('resresres', res);
              if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorCode !== null &&
                res.data.ErrorMessage.ErrorCode === 1
              ) {
                //this.Coupanlist();

                product.IsInCart = true;

                var button_span = null;
                if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "span"
                ) {
                  button_span = document.getElementById(event.target.id);
                } else if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "button"
                ) {
                  var button = document.getElementById(
                    event.target.id
                  ); /* id is unique by definition! */
                  var spans = button.getElementsByTagName("span");
                  if (spans) button_span = spans[0];
                }

                if (button_span !== null) {
                  button_span.innerHTML = CONFIG.DATA.REMOVE_FROM_CART_TEXT;
                  button_span.setAttribute("data-action", "remove");
                }
                toast.info("Item added to cart.", { autoClose: 2000 });
                this.Notification("plus");
              } else if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorDetails !== null
              ) {
                toast.info(res.data.ErrorMessage.ErrorDetails, {
                  autoClose: 2000,
                });
              }
            })
            .catch(function (response) {
              console.log(response);
            });
        } else {
          data.append("method", "POST");
          var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/RemoveFromCart/${product.SSNewsId}/${UserToken}`;
          // data.append(
          //   "apiurl",
          //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/RemoveFromCart/${product.SSNewsId}/${UserToken}`
          // );
          var object = {};
          data.forEach((value, key) => (object[key] = value));
          var jsonData = JSON.stringify(object);

          axios
            .post(apiurl, jsonData, {
              headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
            })
            .then((res) => {
              if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorCode !== null &&
                res.data.ErrorMessage.ErrorCode === 1
              ) {
                //this.Coupanlist();

                product.IsInCart = false;

                var button_span = null;
                if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "span"
                ) {
                  button_span = document.getElementById(event.target.id);
                } else if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "button"
                ) {
                  var button = document.getElementById(
                    event.target.id
                  ); /* id is unique by definition! */
                  var spans = button.getElementsByTagName("span");
                  if (spans) button_span = spans[0];
                }

                if (button_span !== null) {
                  button_span.innerHTML = CONFIG.DATA.ADD_TO_CART_TEXT;
                  button_span.setAttribute("data-action", "add");
                }
                toast.warn("Item removed from cart.", { autoClose: 2000 });
                this.Notification("minus");
              } else if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorDetails !== null
              ) {
                toast.info(res.data.ErrorMessage.ErrorDetails, {
                  autoClose: 2000,
                });
              }
            })
            .catch(function (response) {
              console.log(response);
            });
        }
      }
    }
  };

  Notification(type) {
    var item_count = document
      .getElementById("Notificationcount")
      .getElementsByTagName("span")[0].innerHTML;
    if (type === "plus") {
      item_count++;
    } else {
      item_count--;
    }
    if (item_count !== null && !isNaN(item_count)) {
      item_count = item_count || 0;

      document.getElementById("Notificationcount").innerHTML =
        '<img src="/assets/images/icons/shopingcarticons.png"><span class="badge">' +
        item_count +
        "</span>";
      document.getElementById("tip-cart").innerHTML =
        item_count > 0
          ? "Click to view your shopping cart"
          : "You have no items in your shopping cart";
    }
  }

  showRegister(e) {
    let redirectToPath = window.location.pathname;

    if (window.location.hash !== "")
      redirectToPath = redirectToPath + window.location.hash;

    // console.log(window.location, window.location.hash, redirectToPath);
    // ls.set('redirectTo', redirectToPath);
    ls.set("redirectTo", window.location.href);
    this.props.history.push(
      CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION
        ? "/register"
        : "/simple-register"
    );
    return false;
  }

  TryAutoLogin = async (e) => {
    var fromAOG = ls.get("AOG") === 1;

    if (this.props && this.props.location.search === "?debug=1") {
      console.log("fromAOG: ", fromAOG);
    }

    if (fromAOG) {
      if (this.props && this.props.location.search === "?debug=1") {
        console.log("Calling API: ", fromAOG);
      }

      const data = new FormData();
      data.append("method", "POST");
      // data.append(
      //   "apiurl",
      //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/validateecomshopuser`
      // );
      const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/validateecomshopuser`;

      data.append("MemberNumber", ls.get("MemberNumber"));
      data.append("UserId", ls.get("UserId"));
      data.append("UserToken", ls.get("UserToken"));
      data.append("DeviceId", "3"); // 3 = Web
      data.append("DeviceInfo", "");
      data.append("CustomerId", "1");
      data.append("MobileOS", "");
      data.append("MobileOSVersion", "");
      data.append("MobileModel", "");
      data.append("DeviceRegistrationId", "1.0.0");
      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })
        .then((res) => {
          ls.remove("AOG");

          if (this.props && this.props.location.search === "?debug=1") {
            console.log("ValidateUser", res.data);
          }

          if (
            res.data.ErrorMesasge &&
            res.data.ErrorMesasge.ErrorCode &&
            res.data.ErrorMesasge.ErrorCode <= 0
          ) {
            // wrong spelling here.. mobile api
            toast.error(res.data.ErrorMesasge.ErrorDetails);
          } else if (
            res.data.ErrorMessage &&
            res.data.ErrorMessage.ErrorCode &&
            res.data.ErrorMessage.ErrorCode <= 0
          ) {
            // correct spelling here.. ecom api
            toast.error(res.data.ErrorMessage.ErrorDetails);
          } else {
            // clear previously stored data..
            ls.remove("ClientStores");
            ls.remove("Departments");

            // set fresh data..
            ls.set(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`, res.data);
            ls.set("UserId", res.data.UserId);
            ls.set("UserToken", res.data.UserToken);
            // const redirectTo = ls.get('redirectTo');
            const redirectTo = ls.get("redirectTo");
            if (redirectTo && redirectTo !== "")
              window.location.href = redirectTo;
            else window.location.href = "/";
          }
        })
        .catch(function (res) {
          toast.error("Error Notification !");
        });
    }
  };

  renderDepartment() {
    var dept_info = CONFIG.DATA.DEPARTMENTS || [];

    if (
      this.state.departments &&
      this.state.departments.length > 0 &&
      Object.keys(dept_info.length) == 0 &&
      dept_info.length == 0
    ) {
      return this.state.departments.map((value, index) =>
        value.ProductCategoryId !== 10001 &&
          value.ProductCategoryId !== 10002 ? (
          <div
            key={index}
            className="course-1-items"
            onClick={this.gotoDept(
              "/department/" +
              value.ProductCategoryName.replace(/\s/g, "-").toLowerCase()
            )}
          >
            <figure className="thumnail flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <Link
                    to={
                      "/department/" +
                      value.ProductCategoryName.replace(/\s/g, "-")
                        .replace(/\//g, "_")
                        .toLowerCase()
                    }
                  >
                    <img
                      loading="lazy"
                      src={value.DepartmentImageUrl}
                      title={value.ProductCategoryName}
                      alt={value.ProductCategoryName}
                      className="img-fluid"
                    />
                  </Link>
                  <div className="categorys">
                    {CONFIG.DATA.THEME && CONFIG.DATA.THEME === 2 ? (
                      <span className="dpt_title">
                        {" "}
                        {value.ProductCategoryName}
                      </span>
                    ) : (
                      <h5 className="dpt_title">
                        {" "}
                        {value.ProductCategoryName}
                      </h5>
                    )}
                  </div>
                </div>
                <div
                  className="flip-card-back"
                  onClick={() =>
                    this.props.history.push(
                      "/department/" +
                      value.ProductCategoryName.replace(/\s/g, "-")
                        .replace(/\//g, "_")
                        .toLowerCase()
                    )
                  }
                >
                  <h2>{value.ProductCategoryName}</h2>
                  <p></p>
                  <Link
                    title="Know More"
                    to={
                      "/department/" +
                      value.ProductCategoryName.replace(/\s/g, "-")
                        .replace(/\//g, "_")
                        .toLowerCase()
                    }
                    className="btn btn-danger"
                  >
                    Know more..
                  </Link>
                </div>
              </div>
            </figure>
          </div>
        ) : (
          ""
        )
      );
    } else if (typeof dept_info !== "undefined" && dept_info.length > 0) {
      return dept_info.map((value, index) => (
        <div
          key={index}
          className="wpb_column vc_column_container vc_col-sm-1/5 mb-5"
        >
          <div className="vc_column-inner">
            <div className="wpb_wrapper">
              <div className="vc-hoverbox-wrapper  vc-hoverbox-shape--rounded vc-hoverbox-align--center vc-hoverbox-direction--default vc-hoverbox-width--100">
                <div className="vc-hoverbox" style={{ perspective: 864 }}>
                  <div className="vc-hoverbox-inner" style={{ minHeight: 250 }}>
                    <div
                      className="vc-hoverbox-block vc-hoverbox-front"
                      style={{
                        background: "url(" + value.dept_image + ")",
                        backgroundSize: "cover",
                      }}
                    >
                      {CONFIG.DATA.THEME && CONFIG.DATA.THEME === 2 ? (
                        <div className="">
                          <span className="dpt_title dpt_title2">
                            {" "}
                            {value.departmentname}
                          </span>
                        </div>
                      ) : (
                        <div className="vc-hoverbox-block-inner vc-hoverbox-front-inner">
                          <h2
                            style={{
                              fontSize: 37,
                              color: "#ffffff",
                              textAlign: "center",
                              fontFamily: "Lobster",
                              fontWeight: 400,
                              fontStyle: "normal",
                            }}
                            className="vc_custom_heading text-shadow"
                          >
                            {value.departmentname}
                          </h2>
                        </div>
                      )}
                    </div>

                    <div
                      className="vc-hoverbox-block vc-hoverbox-back"
                      style={{ backgroundColor: "#ebebeb" }}
                    >
                      <div className="vc-hoverbox-block-inner vc-hoverbox-back-inner">
                        <h2 style={{ textAlign: "center" }}>
                          {value.departmentname}
                        </h2>
                        <p style={{ color: "#848484" }}></p>
                        <div className="vc_btn3-container vc_btn3-inline">
                          <Link
                            to={
                              "/department/" +
                              value.slug
                                .replace(/\s/g, "-")
                                .replace(/\//g, "_")
                                .toLowerCase()
                            }
                            className="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-modern vc_btn3-color-danger"
                          >
                            Know More...
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ));
    } else {
      return <div className="content"></div>;
    }
  }

  render() {
    function SampleNextArrow(props) {
      const { className, style, onClick } = props;
      return (
        <div
          className={className}
          style={{ ...style, display: "block" }}
          onClick={onClick}
        />
      );
    }

    function SamplePrevArrow(props) {
      const { className, style, onClick } = props;
      return (
        <div
          className={className}
          style={{ ...style, display: "block" }}
          onClick={onClick}
        />
      );
    }

    const dealoftheweek = this.state.dealoftheweek;
    const weeklyadgallery = this.state.weeklyadgallery;

    // console.log(weeklyadgallery,'weeklyadgallery');
    const departments = this.state.departments;

    const testimonial_slider_options = {
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      center: false,
      loop: true,
      stagePadding: 10,
      margin: 30,
      autoplay: false,
      smartSpeed: 500,
      autoplaySpeed: CONFIG.DATA.SLIDER_SPEED_MS,
      nav: false,
      dots: false,
      lazyLoad: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const top_slider_options = {
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      center: false,
      loop: true,
      stagePadding: 10,
      margin: 30,
      autoplay: CONFIG.DATA.API_HOST !== "localhost", // true, /* Slider Image resolution 1400x630 image size*/
      smartSpeed: 500,
      autoplaySpeed: CONFIG.DATA.SLIDER_SPEED_MS,
      nav: true,
      dots: true,
      lazyLoad: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            nav: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            nav: false,
          },
        },
      ],
    };

    const weekly_ad_deal_slider_options = {
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      center: true,
      loop: true,
      stagePadding: 10,
      margin: 30,
      autoplay: true,
      smartSpeed: 500,
      autoplaySpeed: CONFIG.DATA.SLIDER_SPEED_MS,
      adaptiveHeight: false,
      lazyLoad: true,
      nav: true,
      dots: false,
      arrows: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const departments_slider_options = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: CONFIG.DATA.DEPARTMENTS
        ? Math.min(CONFIG.DATA.DEPARTMENTS.length, 5)
        : Math.min(departments.length - 2, 5),
      slidesToScroll: 5,
      lazyLoad: true,
      center: false,
      loop: true,
      stagePadding: 10,
      margin: 30,
      autoplay: false,
      smartSpeed: 500,
      autoplaySpeed: CONFIG.DATA.SLIDER_SPEED_MS,
      nav: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    var home_slides = CONFIG.DATA.HOME_SLIDER || [];
    // sort by value
    home_slides.sort(function (a, b) {
      return a.slider_index - b.slider_index;
    });

    const slider_html = home_slides.map((slide, index) => {
      if (slide.slider_visible === true) {
        var pattern = /^((http|https|ftp):\/\/)/;
        var isFullSlideClickable =
          slide.slider_button_visible === false &&
          slide.slider_button_link !== "";

        var fileNameOnly = slide.slider_image.split("/").pop().split(".")[0];

        return (
          <div
            key={index}
            className={`cursor-${isFullSlideClickable ? "pointer" : "default"
              } slider_image_parent ${fileNameOnly}`}
            onClick={
              isFullSlideClickable
                ? () => {
                  // console.log("clicked", slide);
                  if (pattern.test(slide.slider_button_link)) {
                    window.location.href = slide.slider_button_link;
                    return false; // <Redirect push to={slide.slider_button_link} />;;
                  } else {
                    // Looks like internal path
                    return this.props.history.push(slide.slider_button_link);
                  }
                }
                : () => { }
            }
          >
            <div
              className={`slider_image intro-section lazy theme-${CONFIG.DATA.THEME} `}
              style={{
                backgroundImage: `url("${slide.slider_image}")`,
              }} /* https://picsum.photos/1500/800 */
            >
              <div className="container slider-container">
                <div
                  className={`row slider_div_row_classname ${slide.slider_div_row_classname}`}
                  style={slide.slider_div_text_style}
                >
                  <div
                    className={`slider_text_div_class ${slide.slider_text_div_class}`}
                    data-aos={`${slide.slider_div_aos_style}`}
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="300"
                  >
                    <h2
                      className={`slider_class_line1 ${slide.slider_class_line1}`}
                      style={slide.slider_style_line1}
                    >
                      {slide.slider_text_line1}{" "}
                    </h2>
                    {slide.slider_text_line2 !== "" ? (
                      <h3
                        className={`slider_style_line2`}
                        style={slide.slider_style_line2}
                      >
                        {slide.slider_text_line2}
                      </h3>
                    ) : (
                      ""
                    )}
                    {slide.slider_button_visible === true ? (
                      pattern.test(slide.slider_button_link) ? (
                        <a
                          target="_blank"
                          title={slide.slider_button_text}
                          href={slide.slider_button_link}
                          className={`slider_button_class slider-button ${slide.slider_button_class}`}
                          style={slide.slider_button_style}
                        >
                          {slide.slider_button_text}
                        </a>
                      ) : (
                        <Link
                          title={slide.slider_button_text}
                          to={slide.slider_button_link}
                          className={`slider_button_class slider-button ${slide.slider_button_class}`}
                          style={slide.slider_button_style}
                        >
                          {slide.slider_button_text}
                        </Link>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
    });

    return (
      <React.Fragment>
        {CONFIG.DATA.ONLY_COUPONS === true ? (
          <div className="main-container full-width pt-5 mt-5">
            <div className="container">
              <div className="row">
                <div className="vc_col-xs-12">
                  <div className="page-content default-page">
                    <article className="page type-page status-publish hentry">
                      <div className="entry-content">
                        <div className="vc_row wpb_row vc_row-fluid">
                          <div
                            className="row-container"
                            style={{ /* marginLeft:'25%',*/ marginTop: "25px" }}
                          >
                            <div className="wpb_column vc_column_container vc_col-sm-10">
                              <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                  <div
                                    className="vc_empty_space"
                                    style={{ height: "150px" }}
                                  >
                                    <span className="vc_empty_space_inner"></span>
                                  </div>
                                  <h2
                                    style={{
                                      fontSize: "42px",
                                      color: "#dd2121",
                                      textAlign: "center",
                                      fontFamily: "Lobster",
                                      fontWeight: "400",
                                      fontStyle: "normal",
                                    }}
                                    className="vc_custom_heading"
                                  >
                                    Coming Soon
                                  </h2>
                                  <div
                                    className="vc_empty_space"
                                    style={{ height: "150px" }}
                                  >
                                    <span className="vc_empty_space_inner"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="Home">
            <div className={`homeslider theme-${CONFIG.DATA.THEME} `}>
              {CONFIG.DATA.BACKEND_HOST === "brothersmarket" ? (
                <img
                  loading="lazy"
                  src={CONFIG.DATA.LOGO_HEADER}
                  alt={CONFIG.DATA.RSA_CLIENT_APP_NAME + " Logo"}
                  title={CONFIG.DATA.RSA_CLIENT_APP_NAME}
                  className="slider-logo"
                  style={{
                    maxWidth: "200px",
                    maxHeight: "75px" /*, maxHeight: '50px' */,
                  }}
                />
              ) : (
                ""
              )}
              <Slider {...top_slider_options}>{slider_html}</Slider>
            </div>
            <div className="" style={{ height: "auto" }}>
              {CONFIG.DATA.THEME === 1 ? (
                <div className="set-weekly-ads theme1">
                  <div className="row">
                    {CONFIG.DATA.BACKEND_HOST === "tealsmarket" ? (
                      <div
                        className="col-lg-6 weeklyads-bg lazy"
                        title="Loyalty Program"
                        style={{
                          display: "flex",
                          textAlign: "center",
                          background: sanitizeUrlForCSS(CONFIG.DATA.LOYALTY_BG_IMG_OR_COLOR),
                        }}
                        onClick={() => this.props.history.push("/loyalty")}
                      >
                        <h2
                          style={{
                            color: "white",
                            textShadow: "rgb(56, 48, 48) 2px 2px",
                          }}
                        ></h2>
                      </div>
                    ) : (
                      <div
                        className="col-lg-6 weeklyads-bg lazy"
                        title="Loyalty Program"
                        style={{
                          display: "block",
                          textAlign: "center",
                          cursor: "pointer",
                          background: sanitizeUrlForCSS(CONFIG.DATA.LOYALTY_BG_IMG_OR_COLOR),
                        }}
                        onClick={() =>
                          CONFIG.DATA.RSA_SUBDOMAIN === "brooksgrocery"
                            ? this.props.history.push("/download-our-app")
                            : this.props.history.push("/loyalty")
                        }
                      >
                        {CONFIG.DATA.RSA_SUBDOMAIN === "brooksgrocery" ? (
                          <h2
                            style={{
                              color: "white",
                              textShadow: "rgb(56, 48, 48) 2px 2px",
                            }}
                          ></h2>
                        ) : (
                          <h2
                            style={{
                              color: "white",
                              textShadow: "rgb(56, 48, 48) 2px 2px",
                              marginTop: "50px",
                              verticalAlign: "middle",
                            }}
                          >
                            Loyalty Program
                          </h2>
                        )}
                      </div>
                    )}
                    {CONFIG.DATA.BACKEND_HOST === "tealsmarket" ? (
                      <div
                        className="col-lg-6 weeklyads-bg lazy"
                        title="senior discount day"
                        style={{
                          display: "flex",
                          textAlign: "center",
                          background: sanitizeUrlForCSS(CONFIG.DATA.NEIGHBORHOOD_BG_IMG_OR_COLOR),
                        }}
                        onClick={() => this.props.history.push("/seniorteals")}
                      >
                        <h2
                          style={{
                            color: "white",
                            textShadow: "rgb(56, 48, 48) 2px 2px",
                          }}
                        ></h2>
                      </div>
                    ) : (
                      // </Link>
                      <div
                        className="col-lg-6 weeklyads-bg lazy"
                        title={CONFIG.DATA.NEIGHBORHOOD_TEXT}
                        style={{
                          display: "block",
                          textAlign: "center",
                          position: "relative",
                          verticalAlign: "middle",
                          width: "100%",
                          height: "150px",
                          background: sanitizeUrlForCSS(CONFIG.DATA.NEIGHBORHOOD_BG_IMG_OR_COLOR),
                          cursor: "pointer",
                        }}
                        onClick={() => this.props.history.push("/contact")}
                      >
                        {CONFIG.DATA.RSA_SUBDOMAIN === "brooksgrocery" ? (
                          ""
                        ) : (
                          <h2
                            style={{
                              color: "white",
                              marginTop: "50px",
                              textShadow: "rgb(56, 48, 48) 2px 2px",
                              textAlign: "center",
                            }}
                          >
                            {CONFIG.DATA.NEIGHBORHOOD_TEXT}
                          </h2>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="row2" style={{ marginTop: "30px" }}>
                  <div className="row mx-5">
                    <div className="col-lg-4 col-sm-12 my-md-2 my-3">
                      <div className="row">
                        <div
                          className="col-md-4 col-sm-12 pr-0 pl-0"
                          title="Loyalty Program"
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <div className="row">
                            <div className="col-12 pr-0 pl-0">
                              <img
                                style={{ height: "114px" }}
                                src={sanitizeUrlForHtml(CONFIG.DATA.LOYALTY_BG_IMG_OR_COLOR)}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-8 col-sm-12  pl-0">
                          <div className="">
                            <h3 className="title">
                              <span>
                                {CONFIG.DATA.RSA_CLIENT_APP_NAME} Loyalty
                                Program
                              </span>
                            </h3>
                            <div className="description">
                              Savings for your family
                            </div>
                            <Link
                              title="Loyalty Program"
                              className="btn btn-theme btn-outline basic-button"
                              to="/loyalty"
                            >
                              Know More{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-12 my-md-2 my-3">
                      <div className="row">
                        <div
                          className="col-md-4 col-lg-5 col-sm-12 pr-0 pl-0"
                          title={CONFIG.DATA.NEIGHBORHOOD_TEXT}
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <div className="row">
                            <div className="col-12 pr-0 pl-0">
                              <img
                                src={sanitizeUrlForHtml(CONFIG.DATA.NEIGHBORHOOD_BG_IMG_OR_COLOR)}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-8 col-lg-7 col-sm-12  pl-0">
                          <div className="">
                            <h3 className="title">
                              <span>{CONFIG.DATA.NEIGHBORHOOD_TEXT}</span>
                            </h3>
                            <div className="description">
                              Everyday Savings...
                            </div>
                            <Link
                              title="Find Locations"
                              className="btn btn-theme btn-outline basic-button"
                              to="/contact"
                            >
                              Find Locations{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-12 my-md-2 my-3">
                      <div className="row">
                        <div
                          className="col-lg-4 col-md-4 col-sm-12 pr-0 pl-0"
                          style={{ textAlign: "center" }}
                        >
                          <div className="row">
                            <div className="col-12">
                              <a
                                href={CONFIG.DATA.APP_URL_ANDROID}
                                title="Download Our Android App"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src="/assets/images/playstore.png"
                                  style={{ height: "66px" }}
                                  alt="Playstore"
                                />
                              </a>
                            </div>
                            <div className="col-12">
                              <a
                                href={CONFIG.DATA.APP_URL_IOS}
                                title="Download Our iPhone App"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src="/assets/images/app_store.png"
                                  style={{ height: "66px" }}
                                  alt="Appstore"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-8 col-md-8 col-sm-12 pl-0 pr-5">
                          <div className="">
                            <h3 className="title">
                              {CONFIG.DATA.BACKEND_HOST ===
                                "silverlakefoods" ? (
                                <span>
                                  iPhone Users! Download NEW Apple App Here!
                                </span>
                              ) : (
                                <span>Download Our Apps Here</span>
                              )}
                            </h3>
                            <div className="description">
                              Exclusive Savings in App
                            </div>
                            <Link
                              title="Download Our Apps"
                              className="btn btn-theme btn-outline basic-button"
                              to="/download-our-app"
                            >
                              Download Here{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className=" adssliders" style={{ marginTop: "25px" }}>
              <div className="container">
                {CONFIG.DATA.THEME && CONFIG.DATA.THEME === 1 ? (
                  <div className="row ">
                    <div className="col-lg-6 Weekly">
                      <h2
                        className="mb-3 "
                        style={{
                          fontFamily: "Lobster, cursive",
                          color: "rgb(255, 58, 45)",
                          fontSize: "40px",
                          textAlign: "center",
                        }}
                      >
                        <span>Weekly Ads</span>
                      </h2>
                      <figure
                        className="thumnail"
                        style={
                          {
                            /* objectFit:'cover', maxHeight:'500px' */
                          }
                        }
                      >
                        <Slider {...weekly_ad_deal_slider_options}>
                          {weeklyadgallery.map((value, index) => (
                            <Link
                              title={value.ClientStoreName}
                              key={index}
                              to={"/weekly-ads"}
                            >
                              <img
                                style={{ height: "auto", maxHeight: "500px" }}
                                src={value.URL}
                                alt="Weekly Ad"
                                title="Weekly Ad"
                                className="img-fluid owl-slide-height"
                              />
                              {value.ClientStoreName}
                            </Link>
                          ))}
                        </Slider>
                      </figure>
                    </div>
                    <div className="col-lg-6 Weekly">
                      <h2
                        className="mb-3 "
                        style={{
                          fontFamily: "Lobster, cursive",
                          color: "rgb(255, 58, 45)",
                          fontSize: "40px",
                          textAlign: "center",
                        }}
                      >
                        <span>Deal of the Week</span>
                      </h2>
                      <figure className="thumnail">
                        <Slider {...weekly_ad_deal_slider_options}>
                          {dealoftheweek && dealoftheweek.length > 0 ? (
                            dealoftheweek.map((value, index) => (
                              <Link
                                title={value.Title}
                                to="/coupons/deals-of-the-week"
                                key={index}
                              >
                                <img
                                  style={{ height: "auto", maxHeight: "500px" }}
                                  src={value.ImagePath}
                                  alt={value.Title}
                                  title={value.Title}
                                  className="img-fluid owl-slide-height"
                                />
                              </Link>
                            ))
                          ) : (
                            <Link
                              title="Deal of the Week"
                              to="/coupons/deals-of-the-week"
                            >
                              <img
                                style={{ height: "auto", maxHeight: "500px" }}
                                src="/assets/images/dealoftheweek.png"
                                alt="Deal of Weeek"
                                className="img-fluid owl-slide-height"
                              />
                            </Link>
                          )}
                        </Slider>
                      </figure>
                    </div>
                  </div>
                ) : (
                  <div className="vc_row wpb_row vc_row-fluid">
                    <div className="wpb_column vc_column_container vc_col-sm-12">
                      <div className="vc_column-inner">
                        <div className="wpb_wrapper">
                          {!CONFIG.DATA.BASIC_THEME ||
                            CONFIG.DATA.BASIC_THEME !== true ? (
                            <React.Fragment>
                              <div
                                className="vc_empty_space"
                                style={{ height: "35px" }}
                              >
                                <span className="vc_empty_space_inner"></span>{" "}
                              </div>
                              <div className="widget widget-text-heading  default">
                                <h3 className="title">Deal of the week</h3>
                                <div className="row ">
                                  <div className="col-lg-12 Weekly">
                                    <figure className="thumnail">
                                      <Slider
                                        {...weekly_ad_deal_slider_options}
                                      >
                                        {dealoftheweek &&
                                          dealoftheweek.length > 0 ? (
                                          dealoftheweek.map((value, index) => (
                                            <div key={index}>
                                              <div
                                                className="col-lg-4"
                                                style={{
                                                  display: "inline-table",
                                                }}
                                              >
                                                <Link
                                                  title={value.Title}
                                                  to="/coupons/deals-of-the-week"
                                                  key={index}
                                                >
                                                  <img
                                                    style={{
                                                      height: "auto",
                                                      maxHeight: "500px",
                                                      margin: "0px auto",
                                                    }}
                                                    src={value.ImagePath}
                                                    alt="Deal of Weeek"
                                                    className="img-fluid owl-slide-height"
                                                  />
                                                </Link>
                                              </div>
                                              <div
                                                className="col-lg-8"
                                                style={{
                                                  display: "inline-table",
                                                  verticalAlign: "top",
                                                  paddingTop: "20px",
                                                }}
                                              >
                                                <div
                                                  className="vc_column-inner"
                                                  style={{}}
                                                >
                                                  <div className="wpb_wrapper">
                                                    <div className="widget widget-text-heading default">
                                                      <h3 className="title slider-text">
                                                        {value.Title}
                                                      </h3>
                                                      <div className="description">
                                                        <p>{value.Details}</p>
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontStyle: "italic",
                                                          }}
                                                        >
                                                          Offer Expires on{" "}
                                                          <Moment
                                                            unix
                                                            format={
                                                              "MM/DD/YYYY"
                                                            }
                                                          >
                                                            {value.ExpiresOn
                                                              ? value.ExpiresOn.replace(
                                                                "/",
                                                                ""
                                                              )
                                                                .replace(
                                                                  "/",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  "Date(",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ")",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  "000+0000",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  " ",
                                                                  ""
                                                                )
                                                              : ""}
                                                          </Moment>
                                                        </p>
                                                      </div>
                                                      <button
                                                        onClick={(e) => {
                                                          this.AddtoCart(
                                                            e,
                                                            index
                                                          );
                                                        }}
                                                        rel="nofollow"
                                                        id={`add_to_cart_${index}`}
                                                        className="quickview btn btn-theme btn-success add_to_cart"
                                                      >
                                                        <span
                                                          id={`span_add_to_cart_${index}`}
                                                          data-action={
                                                            value.IsInCart
                                                              ? "remove"
                                                              : "add"
                                                          }
                                                          className="title-cart"
                                                        >
                                                          {value.IsInCart
                                                            ? CONFIG.DATA
                                                              .REMOVE_FROM_CART_TEXT
                                                            : CONFIG.DATA
                                                              .ADD_TO_CART_TEXT}
                                                        </span>
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ))
                                        ) : (
                                          <Link
                                            title="Deals of the Week"
                                            to="/coupons/deals-of-the-week"
                                          >
                                            <img
                                              style={{
                                                height: "auto",
                                                maxHeight: "500px",
                                              }}
                                              src="/assets/images/dealoftheweek.png"
                                              alt="Deal of Weeek"
                                              className="img-fluid owl-slide-height"
                                            />
                                          </Link>
                                        )}
                                      </Slider>
                                    </figure>
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          ) : (
                            ""
                          )}
                          <div
                            className="vc_empty_space"
                            style={{ height: "35px" }}
                          >
                            <span className="vc_empty_space_inner"></span>
                          </div>
                          <div className="vc_row wpb_row vc_inner vc_row-fluid">
                            <div className="wpb_column vc_column_container vc_col-sm-12">
                              <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                  <div className="widget widget-text-heading  default">
                                    <h3 className="title">
                                      Welcome{" "}
                                      {CONFIG.DATA.BACKEND_HOST ===
                                        "prengerfoods"
                                        ? "Home"
                                        : ""}{" "}
                                      to {CONFIG.DATA.RSA_CLIENT_APP_NAME}
                                    </h3>
                                    <div
                                      className="description"
                                      style={{
                                        color: "#000",
                                        maxHeight: "150px",
                                        overflow: "hidden",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: CONFIG.DATA.ABOUT_FOOTER,
                                      }}
                                    ></div>
                                  </div>
                                  <div
                                    className="vc_empty_space"
                                    style={{ height: "35px" }}
                                  >
                                    <span className="vc_empty_space_inner"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="section-bg style-1" style={{ padding: "0px" }}>
              <div className="container-fluid">
                <div className="row">
                  <div
                    className={`col-lg-${CONFIG.DATA.THEME === 1 ||
                      (CONFIG.DATA.ABOUT_US_LIST &&
                        CONFIG.DATA.ABOUT_US_LIST.length > 0)
                      ? `6`
                      : `12`
                      } `}
                    style={{ padding: "0px" }}
                  >
                    <img
                      title={CONFIG.DATA.RSA_CLIENT_APP_NAME}
                      loading="lazy"
                      alt={CONFIG.DATA.STORE_IMAGE_ALT_TEXT}
                      src={CONFIG.DATA.STORE_IMAGE}
                      style={
                        {
                          /* maxHeight: 411, objectFit: 'cover'*/
                        }
                      }
                      className="img-response"
                    />
                  </div>
                  {CONFIG.DATA.THEME && CONFIG.DATA.THEME === 1 ? (
                    <div
                      className="col-lg-6 aboutus"
                      style={{
                        backgroundColor:
                          CONFIG.DATA.RSA_SUBDOMAIN === "brooksgrocery"
                            ? "#78be21"
                            : "#b7031c",
                      }}
                    >
                      <div className="wpb_wrapper">
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <h3>
                              <span
                                style={{
                                  color: "#ffffff",
                                  fontFamily: "Roboto",
                                  fontSize: "1.6em",
                                  fontStyle: "normal",
                                  textTransform: "uppercase",
                                }}
                              >
                                <strong>About Us</strong>
                              </span>
                            </h3>
                            <p>
                              <span
                                style={{ color: "#ffffff", fontSize: "12pt" }}
                                dangerouslySetInnerHTML={{
                                  __html: CONFIG.DATA.ABOUT_US_DESCRIPTION,
                                }}
                              ></span>
                            </p>
                          </div>
                        </div>
                        <div className="vc_empty_space" style={{ height: 20 }}>
                          <span className="vc_empty_space_inner" />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="about_us wpb_column vc_column_container vc_col-sm-12 vc_col-lg-4 vc_col-md-12">
                      <div className="vc_column-inner">
                        <div className="wpb_wrapper">
                          <div className="widget widget-features-box  ">
                            {CONFIG.DATA.ABOUT_US_LIST ? (
                              CONFIG.DATA.ABOUT_US_LIST.length > 0 ? (
                                <div className="content">
                                  {CONFIG.DATA.ABOUT_US_LIST.map(
                                    (value, index) => (
                                      <div
                                        className="feature-box-inner clearfix"
                                        key={index}
                                      >
                                        <div className="fbox-icon">
                                          <i className={"fa " + value.icon}></i>
                                        </div>
                                        <div className="fbox-content ">
                                          <h3
                                            className="ourservice-heading"
                                            dangerouslySetInnerHTML={{
                                              __html: value.title,
                                            }}
                                          ></h3>
                                          <div
                                            className="description"
                                            dangerouslySetInnerHTML={{
                                              __html: value.description,
                                            }}
                                          ></div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              ) : null
                            ) : (
                              <div className="content">
                                <div className="feature-box-inner clearfix">
                                  <div className="fbox-icon">
                                    <i className="fa fa-heart"></i>
                                  </div>
                                  <div className="fbox-content ">
                                    <h3 className="ourservice-heading">
                                      100% Customer Satisfaction
                                    </h3>
                                    <div className="description">
                                      To give our customers the best quality
                                      products and services at competitive
                                      prices in pleasant and safe conditions
                                    </div>
                                  </div>
                                </div>
                                <div className="feature-box-inner clearfix">
                                  <div className="fbox-icon">
                                    <i className="fa fa-gift"></i>
                                  </div>
                                  <div className="fbox-content ">
                                    <h3 className="ourservice-heading">
                                      Enjoyable Work Environment
                                    </h3>
                                    <div className="description">
                                      To provide our associates and employees a
                                      safe and enjoyable work environment while
                                      providing competitive wage and benefit
                                      compensation.
                                    </div>
                                  </div>
                                </div>
                                <div className="feature-box-inner clearfix">
                                  <div className="fbox-icon">
                                    <i className="fa fa-group"></i>
                                  </div>
                                  <div className="fbox-content ">
                                    <h3 className="ourservice-heading">
                                      Community Projects
                                    </h3>
                                    <div className="description">
                                      Our stores participate in our local
                                      Chambers of Commerce and our managers are
                                      members of local clubs and organizations.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {!CONFIG.DATA.BASIC_THEME || CONFIG.DATA.BASIC_THEME !== true ? (
              <div>
                <div className="container">
                  <div className="row mb-3 pt-5 justify-content-center text-center">
                    <div className="col-lg-6">
                      <h2
                        className=""
                        style={{
                          fontFamily: "Lobster, cursive",
                          color: "rgb(255, 58, 45)",
                          fontSize: "40px",
                          textAlign: "center",
                        }}
                      >
                        <span>Departments</span>
                      </h2>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="Department">
                        <>
                        <Slider {...departments_slider_options}>
                          {CONFIG.DATA.BACKEND_HOST === "eldens" && (
                            <div className="course-1-items">
                              <figure className="thumnail flip-card">
                                <div className="flip-card-inner">
                                    <Link  to="/departments/floral">
                                  <div className="flip-card-front">
                                  <img
                                        src="/assets/images/flower.png"
                                        alt="Floral"
                                        title="Floral"
                                        loading="lazy"
                                        className="img-fluid rounded-xl"
                                         />
                                    <div className="categorys">
                                      {CONFIG.DATA.THEME && CONFIG.DATA.THEME === 2 ? (
                                        <span className="dpt_title">Floral</span>
                                      ) : (
                                        <h5 className="dpt_title">Floral</h5>
                                      )}
                                    </div>
                                  </div>
                                        </Link>
                                  <div className="flip-card-back">
                                    <h2>Floral</h2>
                                    <p></p>
                                    <Link title="Know More" to="/departments/floral" className="btn btn-danger">
                                      Know more..
                                    </Link>
                                  </div>
                                </div>
                              </figure>
                            </div>
                          )}
                          {this.renderDepartment()}
                        </Slider>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {CONFIG.DATA.THEME && CONFIG.DATA.THEME === 1 ? (
              <div className="site-section">
                <div className="container-fluid">
                  <div className="row">
                    {CONFIG.DATA.TESTIMONIAL &&
                      CONFIG.DATA.TESTIMONIAL.length > 0 ? (
                      <div
                        className="col-md-7 lazy"
                        style={{
                          background: CONFIG.DATA.TESTIMONIALS_BG_IMG_OR_COLOR,
                        }}
                      >
                        <Slider {...testimonial_slider_options}>
                          {CONFIG.DATA.TESTIMONIAL.map((value, index) => (
                            <div
                              key={index}
                              className="item carousel-item "
                              style={{}}
                            >
                              <p
                                className="testimonial testimonial_slider_optionstext"
                                style={{
                                  color: CONFIG.DATA.TESTIMONIALS_FONT_COLOR,
                                  fontSize: "16px",
                                }}
                              >
                                {value.post}
                              </p>
                              <p
                                style={{
                                  color: CONFIG.DATA.TESTIMONIALS_FONT_COLOR,
                                  fontSize: "16px",
                                  fontWeight: "normal",
                                }}
                              >
                                {value.designation}
                              </p>
                              <p
                                className="overview"
                                style={{
                                  fontFamily: "Lobster, cursive",
                                  fontSize: 34,
                                }}
                              >
                                <b>{value.name}</b>
                              </p>
                            </div>
                          ))}
                        </Slider>
                      </div>
                    ) : (
                      ""
                    )}
                    <div
                      className={
                        (CONFIG.DATA.TESTIMONIAL.length > 0
                          ? "col-md-5"
                          : "col-md-12 no-testimonial") + " aboutus"
                      }
                      style={{
                        backgroundColor:
                          CONFIG.DATA.RSA_SUBDOMAIN === "brooksgrocery"
                            ? "#78be21"
                            : "#b7031c",
                      }}
                    >
                      <div
                        className={
                          (CONFIG.DATA.TESTIMONIAL.length > 0
                            ? "justify-content-left ml-1 pt-1 "
                            : "justify-content-center ") + "row mb-3 text-left"
                        }
                      >
                        <h2>
                          <span style={{ fontSize: "24pt", color: "#ffffff" }}>
                            Sign up to receive our weekly ad <br />
                            and other offers via email!
                          </span>
                        </h2>
                      </div>
                      <div
                        className="wpforms-container wpforms-container-full"
                        id="wpforms-8447"
                      >
                        <form
                          id="SubscribeForm"
                          className="wpforms-validate wpforms-form"
                          method="post"
                          encType="multipart/form-data"
                          action="/"
                          noValidate="novalidate"
                          style={{}}
                        >
                          <div className="wpforms-field-container">
                            <div
                              id="wpforms-8447-field_1-container"
                              className="wpforms-field wpforms-field-email wpforms-first"
                              data-field-id={1}
                            >
                              <label
                                className="wpforms-field-label wpforms-label-hide"
                                htmlFor="email"
                              >
                                Email{" "}
                                <span className="wpforms-required-label">
                                  *
                                </span>
                              </label>
                              <input
                                type="email"
                                id="tbEmail"
                                className="wpforms-field-large wpforms-field-required"
                                name="email"
                                onChange={this.changeHandler}
                              />
                              <span className="text-white">
                                {this.validator.message(
                                  "email",
                                  this.state.formControls.email,
                                  "required|email"
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="wpforms-submit-container">
                            <button
                              type="submit"
                              name="wpforms[submit]"
                              className="wpforms-submit float-left "
                              id="wpforms-submit-8447"
                              value="wpforms-submit"
                              title="Subscribe"
                              aria-live="assertive"
                              data-alt-text="Sending..."
                              data-submit-text="Submit"
                              style={{ borderRadius: 24 }}
                              onClick={(e) => this.Subscribe(e)}
                            >
                              Subscribe
                            </button>
                          </div>
                        </form>
                      </div>
                      <div
                        className="justify-content-left mt-0 row mb-3 text-left description"
                        style={{ paddingLeft: "10px" }}
                      >
                        <span>
                          By clicking "Subscribe", I agree to receive news,
                          promotions, information and offers from{" "}
                          {CONFIG.DATA.RSA_CLIENT_APP_NAME}. See our{" "}
                          <Link
                            title="Privacy Statements and Terms and Conditions"
                            style={{
                              color: "#fff",
                              textDecoration: "underline",
                            }}
                            to="/company-policies"
                          >
                            Privacy Statements and Terms and Conditions
                          </Link>
                          .
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="site-section subscribe-newsletter-container"
                style={{ paddingBottom: "0em" }}
              >
                <div className="container-fluid">
                  <div
                    className="subscribe-newsletter vc_row wpb_row vc_row-fluid vc_row-has-fill "
                    style={{
                      position: "relative",
                      boxSizing: "border-box",
                      paddingLeft: "100px",
                      paddingRight: "100px",
                      background:
                        CONFIG.DATA.SUBSCRIPTION_BG_IMAGE_OR_COLOR.indexOf(
                          "#"
                        ) === 0
                          ? CONFIG.DATA.SUBSCRIPTION_BG_IMAGE_OR_COLOR
                          : `url("${CONFIG.DATA.SUBSCRIPTION_BG_IMAGE_OR_COLOR}")`,
                      textAlign: "left",
                    }}
                  >
                    <div className="wpb_column vc_column_container">
                      <div className="vc_column-inner">
                        <div className="wpb_wrapper">
                          <div className="widget-newletter  ">
                            <div className="row">
                              <div className="col-sm-12 col-md-7 col-xs-12">
                                <h3 className="title">
                                  Subscribe To Our Newsletter
                                </h3>
                                <div className="description">
                                  Sign up with your email to get updates about
                                  new resources releases and special offers
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-5 col-xs-12  ">
                                <div className="content1 pt-2">
                                  <form
                                    id="SubscribeForm"
                                    className="mc4wp-form mc4wp-form-150"
                                    method="post"
                                    encType="multipart/form-data"
                                    action="/"
                                    noValidate="novalidate"
                                    style={{}}
                                  >
                                    <div className="mc4wp-form-fields">
                                      <div
                                        id="wpforms-8447-field_1-container"
                                        className="input-group"
                                        data-field-id={1}
                                      >
                                        <input
                                          type="email"
                                          id="tbEmail"
                                          className="form-control"
                                          name="email"
                                          placeholder="Enter your email..."
                                          onChange={this.changeHandler}
                                        />
                                        <span className="input-group-btn">
                                          <input
                                            className="btn btn-theme btn-outline basic-button news_letter_subscriber"
                                            type="submit"
                                            value="Subscribe"
                                            name="wpforms[submit]"
                                            title="Subscribe"
                                            id="wpforms-submit-8447"
                                            data-alt-text="Sending..."
                                            data-submit-text="Submit"
                                            onClick={(e) => this.Subscribe(e)}
                                          />
                                        </span>
                                        <span
                                          style={{
                                            color: "red",
                                            display: "block",
                                          }}
                                        >
                                          {this.validator.message(
                                            "email",
                                            this.state.formControls.email,
                                            "required|email"
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                                <div className="description">
                                  By clicking "Subscribe", I agree to receive
                                  news, promotions, information and offers from{" "}
                                  {CONFIG.DATA.RSA_CLIENT_APP_NAME}. See our{" "}
                                  <Link
                                    title="Privacy Statements and Terms and Conditions"
                                    to="/company-policies"
                                  >
                                    Privacy Statements and Terms and Conditions
                                  </Link>
                                  .
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="vc_empty_space"
                            style={{ height: "50px" }}
                          >
                            <span className="vc_empty_space_inner"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(Home);
